export default "__VITE_ASSET__1abea093__"